<template>
  <vs-table hover-flat v-if="timeConditions && timeConditions.length" :data="timeConditions">
    <template slot="thead">
      <vs-th v-text="$t('month')"></vs-th>
      <vs-th v-text="$t('day')"></vs-th>
      <vs-th v-text="$t('day_of_week')"></vs-th>
      <vs-th v-text="$t('time')"></vs-th>
      <vs-th v-text="$t('description')"></vs-th>
      <vs-th class="text-center" v-text="$t('action')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="key" v-for="(tr, key) in data">
        <vs-td v-text="__translateTimeCondition(__getTime(tr.time, 'month'))"></vs-td>
        <vs-td v-text="__getTime(tr.time, 'day')"></vs-td>
        <vs-td v-text="__translateTimeCondition(__getTime(tr.time, 'week'))"></vs-td>
        <vs-td v-text="__getTime(tr.time, 'time')"></vs-td>
        <vs-td v-text="tr.description"></vs-td>
        <vs-td class="text-center">
          <div class="flex justify-center">
            <vs-button color="primary" type="border" icon-pack="feather" icon="icon-edit" size="small" @click="$emit('editTimeCondition', tr.id)"></vs-button>&nbsp;
            <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash-2" size="small" @click="$emit('destroyTimeCondition', tr.id)"></vs-button>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>

export default {
  name: 'Shared.TimeConditions.List',
  props: {
    timeConditions: {
      type: [Object, Array],
      required: true
    }
  },
  methods: {
    __getTime (string, type) {
      const array = string.split('|')

      switch (type) {
      case 'time':
        return array[0]
      case 'week':
        return array[1]
      case 'day':
        return array[2]
      case 'month':
        return array[3]
      }
    },
    __translateTimeCondition (string) {
      if (string.trim() === '*') {
        return string.trim()
      } else {
        if (string.includes('-')) {
          const array = string.split('-')
          const word = []
          word[0] = this.$t(array[0])
          word[1] = this.$t(array[1])
          return word.join('-')
        }

        return this.$t(string.trim())
      }
    }
  }
}
</script>

<style scoped>

</style>
